var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleExclamationSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99935 0C9.4986 0 9.95918 0.267857 10.2123 0.707143L17.8066 13.85C18.0633 14.2929 18.0633 14.8393 17.8137 15.2821C17.564 15.725 17.0964 16 16.5936 16H1.40505C0.902283 16 0.434671 15.725 0.185044 15.2821C-0.0645835 14.8393 -0.0610676 14.2893 0.192076 13.85L7.78637 0.707143C8.03951 0.267857 8.50009 0 8.99935 0ZM8.99935 4.57143C8.53174 4.57143 8.15554 4.95357 8.15554 5.42857V9.42857C8.15554 9.90357 8.53174 10.2857 8.99935 10.2857C9.46696 10.2857 9.84316 9.90357 9.84316 9.42857V5.42857C9.84316 4.95357 9.46696 4.57143 8.99935 4.57143ZM10.1244 12.5714C10.1244 11.9393 9.62166 11.4286 8.99935 11.4286C8.37704 11.4286 7.87427 11.9393 7.87427 12.5714C7.87427 13.2036 8.37704 13.7143 8.99935 13.7143C9.62166 13.7143 10.1244 13.2036 10.1244 12.5714Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamationSolid);
export default __webpack_public_path__ + "static/media/triangle-exclamation-solid.cf64b881506fe1ae8668e77f61d1f8c5.svg";
export { ForwardRef as ReactComponent };